import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { ContractorUpdateDto } from './contractor-update.dto';
import { CONTRACTOR_RELATION_MAX_ITEMS } from './contractor-full-create.dto';

/**
 * Explicit bumper link changes. The API only removes links listed in
 * `remove`, so a client that cannot display every linked bumper (inactive
 * user, paged option list) can never unlink one by omission.
 */
export class ContractorBumperUsersDto {
  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description: 'User ids to link as bumpers.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(CONTRACTOR_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  add?: string[];

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description: 'User ids to unlink. Ids not currently linked are ignored.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(CONTRACTOR_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  remove?: string[];
}

/**
 * Body of PATCH /contractor/:id/full. Omitted keys are left untouched;
 * `regionIds` is a desired set diffed server-side, `bumperUsers` carries
 * explicit add/remove deltas.
 */
export class ContractorFullUpdateDto {
  @ApiPropertyOptional({ type: () => ContractorUpdateDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => ContractorUpdateDto)
  contractor?: ContractorUpdateDto;

  @ApiPropertyOptional({ type: [String], format: 'uuid' })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(CONTRACTOR_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds?: string[];

  @ApiPropertyOptional({ type: () => ContractorBumperUsersDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => ContractorBumperUsersDto)
  bumperUsers?: ContractorBumperUsersDto;
}
